export * from "./config";
export * from "./options";

export const TOOLTIP_CONTENT_FOR_DISABLED_FILTER = "This filter is not applicable or has not yet been implemented for the currently selected tab. It is not affecting the visible results.";
